//import { NgxEditorModule } from 'ngx-editor';

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HtmleditorComponent } from './htmleditor/htmleditor.component';
import { NgxEditorModule } from 'ngx-editor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [HtmleditorComponent],
  exports: [HtmleditorComponent],
  imports: [
    CommonModule,
    NgxEditorModule,
    FormsModule,
    ReactiveFormsModule


  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HtmleditorModule { }
